import { createContext, useContext, useState, useCallback } from "react";

const dict = {
  fr: {
    "app.name": "ALTIORA Career OS",
    "app.tagline": "Le premier système d'exploitation intelligent de trajectoire professionnelle.",
    "nav.dashboard": "Tableau de bord",
    "nav.life_strategy": "Life Strategy™",
    "nav.trust": "Trusted Intelligence™",
    "nav.profile": "Profil & Diagnostic",
    "nav.intelligence": "Career Intelligence",
    "nav.opportunities": "Opportunités",
    "nav.hidden_opportunities": "Hidden Opps™",
    "nav.decision": "Decision Engine™",
    "nav.simulation": "Simulation™",
    "nav.mobility": "Mobility™",
    "nav.graph": "Knowledge Graph",
    "nav.memory": "Learning Memory™",
    "nav.vault": "ALTIORA Vault",
    "nav.documents": "Générateur",
    "nav.tracker": "Candidatures",
    "nav.calendar": "Calendrier",
    "nav.assistant": "Assistant IA",
    "nav.reports": "Rapports",
    "nav.white_label": "White Label",
    "nav.enterprise_api": "Enterprise API",
    "nav.finance": "Finance",
    "nav.gps": "GPS opportunités",
    "nav.alerts": "Alertes",
    "nav.priorities": "Priorités",
    "nav.radar": "Radar",
    "nav.discovery": "Découvertes",
    "nav.knowledge": "Parcours",
    "nav.knowledge_sources": "Sources UKE™",
    "nav.admin_users": "Gestion utilisateurs",
    "nav.admin_docs": "Documentation",
    "nav.today": "Opportunités du jour",
    "nav.network": "Écosystème",
    "nav.diagnostic": "Mon IMES personnel",
    "nav.mentor": "Espace Mentor",
    "nav.communities": "Communautés",
    "nav.library": "Bibliothèque",
    "nav.studio": "Studio",
    "nav.interview": "Prépa entrevue",
    "nav.professionals": "Parler à un pro",
    "nav.modules": "Moteurs",
    "nav.governance": "Gouvernance",
    "nav.admin": "Administration",
    "nav.connectors": "Connectors",
    "nav.partner": "Partner Console",
    "nav.partner_directory": "Partner Directory",
    "nav.founder": "Console Fondateur",
    "nav.logout": "Déconnexion",
    "auth.signin": "Se connecter",
    "auth.signup": "Créer un compte",
    "auth.email": "Adresse courriel",
    "auth.password": "Mot de passe",
    "auth.name": "Nom complet",
    "auth.google": "Continuer avec Google",
    "auth.no_account": "Pas encore de compte ?",
    "auth.have_account": "Déjà inscrit ?",
    "auth.or": "OU",
    "landing.partner_cta": "Espace partenaire",
    "landing.cta": "Composer ma stratégie",
    "landing.cta.secondary": "Voir les moteurs",
    "landing.eyebrow": "Life OS · v1.0",
    "landing.headline_1": "Nous ne vous trouvons",
    "landing.headline_2": "pas un emploi.",
    "landing.headline_3": "Nous concevons votre",
    "landing.headline_4": "stratégie de vie.",
    "landing.subheadline": "ALTIORA orchestre neuf moteurs d'intelligence — carrière, mobilité internationale, finance, formations, opportunités cachées, décision quotidienne — sous un seul méta-orchestrateur, le Life Strategy Engine™. Vous ne recevez pas une liste de recommandations. Vous recevez UNE stratégie cohérente, hiérarchisée par impact global sur onze dimensions de votre vie.",
    "landing.badge_a": "Life Strategy Engine™",
    "landing.badge_b": "Zero-Trust · Multi-tenant",
    "landing.badge_c": "Multi-modèle IA orchestrée",
    "landing.modules_title": "21 modules. Neuf moteurs. Une stratégie.",
    "landing.modules_kicker": "Architecture modulaire enterprise, méta-orchestration au sommet, activation progressive par feature flags.",
    "landing.section_ai": "Un méta-orchestrateur, pas un chatbot",
    "landing.section_ai_body": "ALTIORA route chaque tâche vers le meilleur modèle — Claude pour le coaching, GPT pour la génération, Gemini pour le matching — et fait converger tous les résultats vers UNE stratégie hiérarchisée. Indépendant de tout fournisseur.",
    "landing.section_vault": "Coffre-fort documentaire institutionnel",
    "landing.section_vault_body": "Chiffrement AES-256, journal d'audit immuable, alertes d'expiration, OCR, versioning. Conçu pour l'adoption par des organismes, institutions et gouvernements.",
    "landing.trusted": "Conçu pour les particuliers exigeants, les organismes et les institutions",
    "landing.life_kicker": "Life Strategy Engine™",
    "landing.life_title": "Pas une liste. UNE stratégie.",
    "landing.life_body": "Onze dimensions optimisées simultanément — carrière, mobilité, stabilité, sécurité financière, avantages sociaux, programmes publics, capacité de financement, qualité de vie, équilibre, situation familiale, objectifs personnels.",
    "landing.life_note": "Réservé pour l'instant aux membres du Founder Circle. Ouverture progressive.",
    "dashboard.welcome": "Bonjour",
    "dashboard.score_label": "Score ALTIORA",
    "dashboard.opportunities_label": "Opportunités",
    "dashboard.hidden_label": "Cachées",
    "dashboard.profile_completion": "Complétion du profil",
    "dashboard.run_diagnostic": "Lancer le diagnostic IA",
    "dashboard.modules_title": "Modules disponibles",
    "profile.title": "Profil & Diagnostic",
    "profile.subtitle": "Fondation de votre OS de carrière.",
    "profile.headline": "Titre professionnel",
    "profile.summary": "Résumé de carrière",
    "profile.current_role": "Poste actuel",
    "profile.years": "Années d'expérience",
    "profile.target_roles": "Rôles ciblés (séparés par des virgules)",
    "profile.locations": "Lieux ciblés",
    "profile.industries": "Industries",
    "profile.languages": "Langues parlées",
    "profile.skills": "Compétences (séparées par des virgules)",
    "profile.linkedin": "Profil LinkedIn",
    "profile.save": "Enregistrer",
    "profile.diagnostic": "Diagnostic IA",
    "profile.run": "Analyser mon profil",
    "intelligence.title": "Career Intelligence",
    "intelligence.subtitle": "Score ALTIORA d'employabilité et recommandations IA.",
    "intelligence.narrative": "Générer un rapport IA",
    "intelligence.get_recos": "Recommandations IA",
    "intelligence.dimensions": "Dimensions du score",
    "opportunities.title": "Opportunity Engine",
    "opportunities.subtitle": "Offres visibles et opportunités cachées, classées par IA.",
    "opportunities.hidden": "Cachée",
    "opportunities.visible": "Visible",
    "opportunities.match": "Lancer le matching IA",
    "opportunities.save": "Sauvegarder",
    "opportunities.apply": "Marquer postulé",
    "opportunities.dismiss": "Ignorer",
    "opportunities.filter_all": "Toutes",
    "opportunities.filter_visible": "Visibles",
    "opportunities.filter_hidden": "Cachées",
    "opportunities.filter_remote": "Télétravail",
    "founder.title": "Console Fondateur",
    "founder.subtitle": "Feature flags & pilotage des modules ALTIORA.",
    "founder.self_promote": "Activer le mode Fondateur",
    "founder.promoted": "Mode Fondateur actif",
    "assistant.title": "Assistant IA ALTIORA",
    "assistant.placeholder": "Posez votre question de carrière...",
    "assistant.send": "Envoyer",
    "assistant.subtitle": "Multi-modèles orchestrés — voice-ready.",
    "common.save": "Enregistrer",
    "common.cancel": "Annuler",
    "common.loading": "Chargement…",
    "common.coming_soon": "Bientôt disponible",
    "common.planned": "Prévu",
    "common.active": "Actif",
    "common.beta": "Bêta",
    "common.premium": "Premium",
    "common.founder_only": "Fondateur",
    "common.language": "Langue",
  },
  en: {
    "app.name": "ALTIORA Career OS",
    "app.tagline": "The first intelligent operating system for career trajectory.",
    "nav.dashboard": "Dashboard",
    "nav.life_strategy": "Life Strategy™",
    "nav.trust": "Trusted Intelligence™",
    "nav.profile": "Profile & Diagnostic",
    "nav.intelligence": "Career Intelligence",
    "nav.opportunities": "Opportunities",
    "nav.hidden_opportunities": "Hidden Opps™",
    "nav.decision": "Decision Engine™",
    "nav.simulation": "Simulation™",
    "nav.mobility": "Mobility™",
    "nav.graph": "Knowledge Graph",
    "nav.memory": "Learning Memory™",
    "nav.vault": "ALTIORA Vault",
    "nav.documents": "Generator",
    "nav.tracker": "Applications",
    "nav.calendar": "Calendar",
    "nav.assistant": "AI Assistant",
    "nav.reports": "Reports",
    "nav.white_label": "White Label",
    "nav.enterprise_api": "Enterprise API",
    "nav.finance": "Finance",
    "nav.gps": "Opportunities GPS",
    "nav.alerts": "Alerts",
    "nav.priorities": "Priorities",
    "nav.radar": "Radar",
    "nav.discovery": "Discovery",
    "nav.knowledge": "Journeys",
    "nav.knowledge_sources": "UKE™ Sources",
    "nav.admin_users": "User Management",
    "nav.admin_docs": "Documentation",
    "nav.today": "Today's Opportunities",
    "nav.network": "Ecosystem",
    "nav.diagnostic": "My IMES™",
    "nav.mentor": "Mentor space",
    "nav.communities": "Communities",
    "nav.library": "Library",
    "nav.interview": "Interview Prep",
    "nav.professionals": "Talk to a pro",
    "nav.modules": "Engines",
    "nav.governance": "Governance",
    "nav.admin": "Administration",
    "nav.connectors": "Connectors",
    "nav.partner": "Partner Console",
    "nav.partner_directory": "Partner Directory",
    "nav.founder": "Founder Console",
    "nav.logout": "Sign out",
    "auth.signin": "Sign in",
    "auth.signup": "Create account",
    "auth.email": "Email address",
    "auth.password": "Password",
    "auth.name": "Full name",
    "auth.google": "Continue with Google",
    "auth.no_account": "No account yet?",
    "auth.have_account": "Already registered?",
    "auth.or": "OR",
    "landing.partner_cta": "Partner access",
    "landing.cta": "Compose my strategy",
    "landing.cta.secondary": "See the engines",
    "landing.eyebrow": "Life OS · v1.0",
    "landing.headline_1": "We don't find",
    "landing.headline_2": "you a job.",
    "landing.headline_3": "We design your",
    "landing.headline_4": "life strategy.",
    "landing.subheadline": "ALTIORA orchestrates nine intelligence engines — career, international mobility, finance, training, hidden opportunities, daily decisions — under a single meta-orchestrator, the Life Strategy Engine™. You don't get a list of recommendations. You get ONE coherent strategy, hierarchised by global impact across eleven dimensions of your life.",
    "landing.badge_a": "Life Strategy Engine™",
    "landing.badge_b": "Zero-Trust · Multi-tenant",
    "landing.badge_c": "Multi-model AI orchestration",
    "landing.modules_title": "21 modules. Nine engines. One strategy.",
    "landing.modules_kicker": "Enterprise-grade modular architecture, meta-orchestration on top, progressive activation via feature flags.",
    "landing.section_ai": "A meta-orchestrator, not a chatbot",
    "landing.section_ai_body": "ALTIORA routes every task to the best-suited model — Claude for coaching, GPT for generation, Gemini for matching — and converges every output into ONE hierarchised strategy. Independent of any single vendor.",
    "landing.section_vault": "Institutional-grade document vault",
    "landing.section_vault_body": "AES-256 encryption, immutable audit trail, expiry alerts, OCR, versioning. Built for adoption by organisations, institutions and governments.",
    "landing.trusted": "Built for demanding individuals, organisations and institutions",
    "landing.life_kicker": "Life Strategy Engine™",
    "landing.life_title": "Not a list. ONE strategy.",
    "landing.life_body": "Eleven dimensions jointly optimised — career, mobility, stability, financial security, social benefits, public programs, financing capacity, quality of life, balance, family situation, personal objectives.",
    "landing.life_note": "Currently reserved for Founder Circle members. Progressive rollout.",
    "dashboard.welcome": "Welcome",
    "dashboard.score_label": "ALTIORA Score",
    "dashboard.opportunities_label": "Opportunities",
    "dashboard.hidden_label": "Hidden",
    "dashboard.profile_completion": "Profile completion",
    "dashboard.run_diagnostic": "Run AI diagnostic",
    "dashboard.modules_title": "Available modules",
    "profile.title": "Profile & Diagnostic",
    "profile.subtitle": "Foundation of your Career OS.",
    "profile.headline": "Professional headline",
    "profile.summary": "Career summary",
    "profile.current_role": "Current role",
    "profile.years": "Years of experience",
    "profile.target_roles": "Target roles (comma-separated)",
    "profile.locations": "Target locations",
    "profile.industries": "Industries",
    "profile.languages": "Languages",
    "profile.skills": "Skills (comma-separated)",
    "profile.linkedin": "LinkedIn URL",
    "profile.save": "Save",
    "profile.diagnostic": "AI Diagnostic",
    "profile.run": "Analyze my profile",
    "intelligence.title": "Career Intelligence",
    "intelligence.subtitle": "ALTIORA employability score and AI recommendations.",
    "intelligence.narrative": "Generate AI report",
    "intelligence.get_recos": "AI recommendations",
    "intelligence.dimensions": "Score dimensions",
    "opportunities.title": "Opportunity Engine",
    "opportunities.subtitle": "Visible offers and hidden opportunities, ranked by AI.",
    "opportunities.hidden": "Hidden",
    "opportunities.visible": "Visible",
    "opportunities.match": "Run AI matching",
    "opportunities.save": "Save",
    "opportunities.apply": "Mark applied",
    "opportunities.dismiss": "Dismiss",
    "opportunities.filter_all": "All",
    "opportunities.filter_visible": "Visible",
    "opportunities.filter_hidden": "Hidden",
    "opportunities.filter_remote": "Remote",
    "founder.title": "Founder Console",
    "founder.subtitle": "Feature flags & ALTIORA module control.",
    "founder.self_promote": "Enable Founder Mode",
    "founder.promoted": "Founder Mode active",
    "assistant.title": "ALTIORA AI Assistant",
    "assistant.placeholder": "Ask your career question...",
    "assistant.send": "Send",
    "assistant.subtitle": "Multi-model orchestrated — voice-ready.",
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.loading": "Loading…",
    "common.coming_soon": "Coming soon",
    "common.planned": "Planned",
    "common.active": "Active",
    "common.beta": "Beta",
    "common.premium": "Premium",
    "common.founder_only": "Founder",
    "common.language": "Language",
  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("altiora_lang") || "fr");

  const changeLang = useCallback((next) => {
    setLang(next);
    localStorage.setItem("altiora_lang", next);
  }, []);

  const t = useCallback((key) => (dict[lang] && dict[lang][key]) || key, [lang]);

  return (
    <I18nContext.Provider value={{ lang, setLang: changeLang, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export const useI18n = () => useContext(I18nContext);
